export const LANGS_REG = [
  ['fr', '🇫🇷 Français'],
  ['de', '🇩🇪 Deutsch'],
  ['it', '🇮🇹 Italiano'],
  ['es', '🇪🇸 Español'],
  ['pt', '🇵🇹 Português'],
  ['nl', '🇳🇱 Nederlands'],
  ['pl', '🇵🇱 Polski'],
  ['sv', '🇸🇪 Svenska'],
  ['da', '🇩🇰 Dansk'],
  ['no', '🇳🇴 Norsk'],
  ['fi', '🇫🇮 Suomi'],
  ['cs', '🇨🇿 Čeština'],
  ['ro', '🇷🇴 Română'],
  ['hu', '🇭🇺 Magyar'],
  ['hr', '🇭🇷 Hrvatski'],
  ['sk', '🇸🇰 Slovenčina'],
  ['sl', '🇸🇮 Slovenščina'],
  ['et', '🇪🇪 Eesti'],
  ['lv', '🇱🇻 Latviešu'],
  ['lt', '🇱🇹 Lietuvių'],
  ['sq', '🇦🇱 Shqip'],
  ['is', '🇮🇸 Íslenska'],
  ['el', '🇬🇷 Ελληνικά'],
  ['bg', '🇧🇬 Български'],
  ['ru', '🇷🇺 Русский'],
  ['uk', '🇺🇦 Українська'],
  ['sr', '🇷🇸 Srpski'],
  ['mk', '🇲🇰 Македонски'],
  ['tr', '🇹🇷 Türkçe'],
  ['ar', '🇸🇦 العربية'],
  ['zh', '🇨🇳 中文'],
  ['ja', '🇯🇵 日本語'],
  ['ko', '🇰🇷 한국어'],
  ['hi', '🇮🇳 हिन्दी'],
  ['id', '🇮🇩 Indonesia'],
  ['vi', '🇻🇳 Tiếng Việt'],
  ['th', '🇹🇭 ไทย'],
  ['ms', '🇲🇾 Melayu'],
  ['tl', '🇵🇭 Filipino'],
  ['fa', '🇮🇷 فارسی'],
  ['ur', '🇵🇰 اردو'],
  ['he', '🇮🇱 עברית'],
  ['sw', '🇰🇪 Kiswahili'],
  ['bn', '🇧🇩 বাংলা'],
  ['si', '🇱🇰 සිංහල'],
  ['ne', '🇳🇵 नेपाली'],
  ['am', '🇪🇹 አማርኛ'],
  ['kk', '🇰🇿 Қазақ'],
  ['uz', '🇺🇿 Oʻzbek'],
  ['ka', '🇬🇪 ქართული'],
  ['hy', '🇦🇲 Հայերեն'],
  ['az', '🇦🇿 Azərbaycan'],
  ['km', '🇰🇭 ខ្មែរ'],
  ['my', '🇲🇲 မြန်မာ'],
  ['mn', '🇲🇳 Монгол'],
  ['lo', '🇱🇦 ລາວ'],
  ['ca', '🇦🇩 Català'],
  ['zh-tw', '🇹🇼 繁體中文'],
  ['af', '🇿🇦 Afrikaans'],
  ['ha', '🇳🇬 Hausa'],
  ['ak', '🇬🇭 Twi'],
  ['rw', '🇷🇼 Kinyarwanda'],
  ['ny', '🇿🇲 Chichewa'],
  ['sn', '🇿🇼 chiShona'],
  ['tn', '🇧🇼 Setswana'],
  ['mg', '🇲🇬 Malagasy'],
  ['mt', '🇲🇹 Malti'],
  ['be', '🇧🇾 Беларуская'],
  ['bs', '🇧🇦 Bosanski'],
  ['en', '🇬🇧 English'],
  ['ps', '🇦🇫 پښتو'],
  ['so', '🇸🇴 Soomaali'],
  ['ht', '🇭🇹 Kreyòl ayisyen'],
  ['ky', '🇰🇬 Кыргызча'],
  ['tg', '🇹🇯 Тоҷикӣ'],
  ['tk', '🇹🇲 Türkmençe'],
  ['ti', '🇪🇷 ትግርኛ'],
  ['rn', '🇧🇮 Ikirundi'],
  ['sm', '🇼🇸 Gagana Sāmoa'],
  ['to', '🇹🇴 Lea faka-Tonga'],
  ['dz', '🇧🇹 རྫོང་ཁ'],
  ['dv', '🇲🇻 ދިވެހި'],
  ['st', '🇱🇸 Sesotho'],
  ['ss', '🇸🇿 siSwati'],
];

export const DEVISES_REG = [
  ['CHF', 'CHF — Franc suisse'],
  ['EUR', '€ — Euro'],
  ['USD', '$ — Dollar US'],
];

export const PAYS = [
  { code: 'CH', nom: 'Suisse', devise: 'CHF', tva: [8.1, 3.8, 2.6, 0], paiement: 'qr' },
  { code: 'FR', nom: 'France', devise: '€', tva: [20, 10, 5.5, 2.1, 0], paiement: 'iban' },
  { code: 'DE', nom: 'Allemagne', devise: '€', tva: [19, 7, 0], paiement: 'iban' },
  { code: 'IT', nom: 'Italie', devise: '€', tva: [22, 10, 5, 4, 0], paiement: 'iban' },
  { code: 'BE', nom: 'Belgique', devise: '€', tva: [21, 12, 6, 0], paiement: 'iban' },
  { code: 'NL', nom: 'Pays-Bas', devise: '€', tva: [21, 9, 0], paiement: 'iban' },
  { code: 'LU', nom: 'Luxembourg', devise: '€', tva: [17, 14, 8, 3, 0], paiement: 'iban' },
  { code: 'ES', nom: 'Espagne', devise: '€', tva: [21, 10, 4, 0], paiement: 'iban' },
  { code: 'PT', nom: 'Portugal', devise: '€', tva: [23, 13, 6, 0], paiement: 'iban' },
  { code: 'AT', nom: 'Autriche', devise: '€', tva: [20, 13, 10, 0], paiement: 'iban' },
  { code: 'IE', nom: 'Irlande', devise: '€', tva: [23, 13.5, 9, 4.8, 0], paiement: 'iban' },
  { code: 'FI', nom: 'Finlande', devise: '€', tva: [25.5, 14, 10, 0], paiement: 'iban' },
  { code: 'GR', nom: 'Grèce', devise: '€', tva: [24, 13, 6, 0], paiement: 'iban' },
  { code: 'PL', nom: 'Pologne', devise: 'zł', tva: [23, 8, 5, 0], paiement: 'iban' },
  { code: 'CZ', nom: 'Tchéquie', devise: 'Kč', tva: [21, 12, 0], paiement: 'iban' },
  { code: 'SK', nom: 'Slovaquie', devise: '€', tva: [23, 19, 5, 0], paiement: 'iban' },
  { code: 'HU', nom: 'Hongrie', devise: 'Ft', tva: [27, 18, 5, 0], paiement: 'iban' },
  { code: 'RO', nom: 'Roumanie', devise: 'lei', tva: [19, 9, 5, 0], paiement: 'iban' },
  { code: 'BG', nom: 'Bulgarie', devise: 'лв', tva: [20, 9, 0], paiement: 'iban' },
  { code: 'HR', nom: 'Croatie', devise: '€', tva: [25, 13, 5, 0], paiement: 'iban' },
  { code: 'SI', nom: 'Slovénie', devise: '€', tva: [22, 9.5, 5, 0], paiement: 'iban' },
  { code: 'EE', nom: 'Estonie', devise: '€', tva: [22, 9, 0], paiement: 'iban' },
  { code: 'LV', nom: 'Lettonie', devise: '€', tva: [21, 12, 5, 0], paiement: 'iban' },
  { code: 'LT', nom: 'Lituanie', devise: '€', tva: [21, 9, 5, 0], paiement: 'iban' },
  { code: 'CY', nom: 'Chypre', devise: '€', tva: [19, 9, 5, 0], paiement: 'iban' },
  { code: 'MT', nom: 'Malte', devise: '€', tva: [18, 7, 5, 0], paiement: 'iban' },
  { code: 'DK', nom: 'Danemark', devise: 'kr', tva: [25, 0], paiement: 'iban' },
  { code: 'SE', nom: 'Suède', devise: 'kr', tva: [25, 12, 6, 0], paiement: 'iban' },
  { code: 'NO', nom: 'Norvège', devise: 'kr', tva: [25, 15, 12, 0], paiement: 'iban' },
  { code: 'IS', nom: 'Islande', devise: 'kr', tva: [24, 11, 0], paiement: 'iban' },
  { code: 'GB', nom: 'Royaume-Uni', devise: '£', tva: [20, 5, 0], paiement: 'generic' },
  { code: 'US', nom: 'États-Unis', devise: '$', tva: [0], paiement: 'generic' },
  { code: 'CA', nom: 'Canada', devise: '$', tva: [5, 0], paiement: 'generic' },
  { code: 'MX', nom: 'Mexique', devise: '$', tva: [16, 8, 0], paiement: 'generic' },
  { code: 'BR', nom: 'Brésil', devise: 'R$', tva: [17, 12, 7, 0], paiement: 'generic' },
  { code: 'AR', nom: 'Argentine', devise: '$', tva: [21, 10.5, 0], paiement: 'generic' },
  { code: 'CL', nom: 'Chili', devise: '$', tva: [19, 0], paiement: 'generic' },
  { code: 'CO', nom: 'Colombie', devise: '$', tva: [19, 5, 0], paiement: 'generic' },
  { code: 'PE', nom: 'Pérou', devise: 'S/', tva: [18, 0], paiement: 'generic' },
  { code: 'UY', nom: 'Uruguay', devise: '$U', tva: [22, 10, 0], paiement: 'generic' },
  { code: 'VE', nom: 'Venezuela', devise: 'Bs', tva: [16, 8, 0], paiement: 'generic' },
  { code: 'EC', nom: 'Équateur', devise: '$', tva: [15, 0], paiement: 'generic' },
  { code: 'BO', nom: 'Bolivie', devise: 'Bs', tva: [13, 0], paiement: 'generic' },
  { code: 'PY', nom: 'Paraguay', devise: '₲', tva: [10, 5, 0], paiement: 'generic' },
  { code: 'AU', nom: 'Australie', devise: '$', tva: [10, 0], paiement: 'generic' },
  { code: 'NZ', nom: 'Nouvelle-Zélande', devise: '$', tva: [15, 0], paiement: 'generic' },
  { code: 'JP', nom: 'Japon', devise: '¥', tva: [10, 8, 0], paiement: 'generic' },
  { code: 'CN', nom: 'Chine', devise: '¥', tva: [13, 9, 6, 0], paiement: 'generic' },
  { code: 'KR', nom: 'Corée du Sud', devise: '₩', tva: [10, 0], paiement: 'generic' },
  { code: 'IN', nom: 'Inde', devise: '₹', tva: [18, 12, 5, 28, 0], paiement: 'generic' },
  { code: 'ID', nom: 'Indonésie', devise: 'Rp', tva: [11, 0], paiement: 'generic' },
  { code: 'MY', nom: 'Malaisie', devise: 'RM', tva: [10, 6, 0], paiement: 'generic' },
  { code: 'SG', nom: 'Singapour', devise: '$', tva: [9, 0], paiement: 'generic' },
  { code: 'TH', nom: 'Thaïlande', devise: '฿', tva: [7, 0], paiement: 'generic' },
  { code: 'PH', nom: 'Philippines', devise: '₱', tva: [12, 0], paiement: 'generic' },
  { code: 'VN', nom: 'Viêt Nam', devise: '₫', tva: [10, 8, 5, 0], paiement: 'generic' },
  { code: 'TW', nom: 'Taïwan', devise: '$', tva: [5, 0], paiement: 'generic' },
  { code: 'HK', nom: 'Hong Kong', devise: '$', tva: [0], paiement: 'generic' },
  { code: 'PK', nom: 'Pakistan', devise: '₨', tva: [18, 0], paiement: 'generic' },
  { code: 'BD', nom: 'Bangladesh', devise: '৳', tva: [15, 0], paiement: 'generic' },
  { code: 'LK', nom: 'Sri Lanka', devise: 'Rs', tva: [18, 0], paiement: 'generic' },
  { code: 'NP', nom: 'Népal', devise: '₨', tva: [13, 0], paiement: 'generic' },
  { code: 'AE', nom: 'Émirats arabes unis', devise: 'AED', tva: [5, 0], paiement: 'generic' },
  { code: 'SA', nom: 'Arabie saoudite', devise: 'SAR', tva: [15, 0], paiement: 'generic' },
  { code: 'QA', nom: 'Qatar', devise: 'QAR', tva: [0], paiement: 'generic' },
  { code: 'KW', nom: 'Koweït', devise: 'KWD', tva: [0], paiement: 'generic' },
  { code: 'BH', nom: 'Bahreïn', devise: 'BHD', tva: [10, 0], paiement: 'generic' },
  { code: 'OM', nom: 'Oman', devise: 'OMR', tva: [5, 0], paiement: 'generic' },
  { code: 'JO', nom: 'Jordanie', devise: 'JD', tva: [16, 0], paiement: 'generic' },
  { code: 'LB', nom: 'Liban', devise: '£L', tva: [11, 0], paiement: 'generic' },
  { code: 'IL', nom: 'Israël', devise: '₪', tva: [17, 0], paiement: 'generic' },
  { code: 'TR', nom: 'Turquie', devise: '₺', tva: [20, 10, 1, 0], paiement: 'generic' },
  { code: 'EG', nom: 'Égypte', devise: 'E£', tva: [14, 0], paiement: 'generic' },
  { code: 'MA', nom: 'Maroc', devise: 'DH', tva: [20, 14, 10, 7, 0], paiement: 'generic' },
  { code: 'TN', nom: 'Tunisie', devise: 'DT', tva: [19, 13, 7, 0], paiement: 'generic' },
  { code: 'DZ', nom: 'Algérie', devise: 'DA', tva: [19, 9, 0], paiement: 'generic' },
  { code: 'ZA', nom: 'Afrique du Sud', devise: 'R', tva: [15, 0], paiement: 'generic' },
  { code: 'NG', nom: 'Nigéria', devise: '₦', tva: [7.5, 0], paiement: 'generic' },
  { code: 'KE', nom: 'Kenya', devise: 'KSh', tva: [16, 0], paiement: 'generic' },
  { code: 'GH', nom: 'Ghana', devise: '₵', tva: [15, 0], paiement: 'generic' },
  { code: 'CI', nom: "Côte d'Ivoire", devise: 'FCFA', tva: [18, 9, 0], paiement: 'generic' },
  { code: 'SN', nom: 'Sénégal', devise: 'FCFA', tva: [18, 0], paiement: 'generic' },
  { code: 'CM', nom: 'Cameroun', devise: 'FCFA', tva: [19.25, 0], paiement: 'generic' },
  { code: 'ET', nom: 'Éthiopie', devise: 'Br', tva: [15, 0], paiement: 'generic' },
  { code: 'TZ', nom: 'Tanzanie', devise: 'TSh', tva: [18, 0], paiement: 'generic' },
  { code: 'UG', nom: 'Ouganda', devise: 'USh', tva: [18, 0], paiement: 'generic' },
  { code: 'RW', nom: 'Rwanda', devise: 'FRw', tva: [18, 0], paiement: 'generic' },
  { code: 'AO', nom: 'Angola', devise: 'Kz', tva: [14, 0], paiement: 'generic' },
  { code: 'CD', nom: 'RD Congo', devise: 'FC', tva: [16, 0], paiement: 'generic' },
  { code: 'CG', nom: 'Congo', devise: 'FCFA', tva: [18, 0], paiement: 'generic' },
  { code: 'GA', nom: 'Gabon', devise: 'FCFA', tva: [18, 0], paiement: 'generic' },
  { code: 'ML', nom: 'Mali', devise: 'FCFA', tva: [18, 0], paiement: 'generic' },
  { code: 'BF', nom: 'Burkina Faso', devise: 'FCFA', tva: [18, 0], paiement: 'generic' },
  { code: 'BJ', nom: 'Bénin', devise: 'FCFA', tva: [18, 0], paiement: 'generic' },
  { code: 'TG', nom: 'Togo', devise: 'FCFA', tva: [18, 0], paiement: 'generic' },
  { code: 'NE', nom: 'Niger', devise: 'FCFA', tva: [19, 0], paiement: 'generic' },
  { code: 'GN', nom: 'Guinée', devise: 'FG', tva: [18, 0], paiement: 'generic' },
  { code: 'MG', nom: 'Madagascar', devise: 'Ar', tva: [20, 0], paiement: 'generic' },
  { code: 'MU', nom: 'Maurice', devise: 'Rs', tva: [15, 0], paiement: 'generic' },
  { code: 'RU', nom: 'Russie', devise: '₽', tva: [20, 10, 0], paiement: 'generic' },
  { code: 'UA', nom: 'Ukraine', devise: '₴', tva: [20, 7, 0], paiement: 'generic' },
  { code: 'BY', nom: 'Biélorussie', devise: 'Br', tva: [20, 10, 0], paiement: 'generic' },
  { code: 'KZ', nom: 'Kazakhstan', devise: '₸', tva: [12, 0], paiement: 'generic' },
  { code: 'UZ', nom: 'Ouzbékistan', devise: 'сўм', tva: [12, 0], paiement: 'generic' },
  { code: 'GE', nom: 'Géorgie', devise: '₾', tva: [18, 0], paiement: 'generic' },
  { code: 'AM', nom: 'Arménie', devise: '֏', tva: [20, 0], paiement: 'generic' },
  { code: 'AZ', nom: 'Azerbaïdjan', devise: '₼', tva: [18, 0], paiement: 'generic' },
  { code: 'RS', nom: 'Serbie', devise: 'дин', tva: [20, 10, 0], paiement: 'generic' },
  { code: 'BA', nom: 'Bosnie-Herzégovine', devise: 'KM', tva: [17, 0], paiement: 'generic' },
  { code: 'MK', nom: 'Macédoine du Nord', devise: 'ден', tva: [18, 5, 0], paiement: 'generic' },
  { code: 'AL', nom: 'Albanie', devise: 'L', tva: [20, 6, 0], paiement: 'generic' },
  { code: 'ME', nom: 'Monténégro', devise: '€', tva: [21, 7, 0], paiement: 'generic' },
  { code: 'MD', nom: 'Moldavie', devise: 'L', tva: [20, 8, 0], paiement: 'generic' },
  { code: 'LI', nom: 'Liechtenstein', devise: 'CHF', tva: [8.1, 3.8, 2.6, 0], paiement: 'qr' },
  { code: 'MC', nom: 'Monaco', devise: '€', tva: [20, 10, 5.5, 2.1, 0], paiement: 'iban' },
  { code: 'AD', nom: 'Andorre', devise: '€', tva: [4.5, 1, 0], paiement: 'iban' },
  { code: 'SM', nom: 'Saint-Marin', devise: '€', tva: [0], paiement: 'iban' },
  { code: 'XK', nom: 'Kosovo', devise: '€', tva: [18, 8, 0], paiement: 'generic' },
  { code: 'CR', nom: 'Costa Rica', devise: '₡', tva: [13, 0], paiement: 'generic' },
  { code: 'PA', nom: 'Panama', devise: '$', tva: [7, 0], paiement: 'generic' },
  { code: 'GT', nom: 'Guatemala', devise: 'Q', tva: [12, 0], paiement: 'generic' },
  { code: 'HN', nom: 'Honduras', devise: 'L', tva: [15, 0], paiement: 'generic' },
  { code: 'SV', nom: 'Salvador', devise: '$', tva: [13, 0], paiement: 'generic' },
  { code: 'NI', nom: 'Nicaragua', devise: 'C$', tva: [15, 0], paiement: 'generic' },
  { code: 'DO', nom: 'Rép. dominicaine', devise: 'RD$', tva: [18, 0], paiement: 'generic' },
  { code: 'CU', nom: 'Cuba', devise: '$', tva: [0], paiement: 'generic' },
  { code: 'IR', nom: 'Iran', devise: '﷼', tva: [9, 0], paiement: 'generic' },
  { code: 'IQ', nom: 'Irak', devise: 'ع.د', tva: [0], paiement: 'generic' },
  { code: 'KH', nom: 'Cambodge', devise: '៛', tva: [10, 0], paiement: 'generic' },
  { code: 'MM', nom: 'Myanmar', devise: 'K', tva: [5, 0], paiement: 'generic' },
  { code: 'MN', nom: 'Mongolie', devise: '₮', tva: [10, 0], paiement: 'generic' },
  { code: 'LA', nom: 'Laos', devise: '₭', tva: [10, 0], paiement: 'generic' },
  { code: 'BN', nom: 'Brunei', devise: '$', tva: [0], paiement: 'generic' },
  { code: 'ZM', nom: 'Zambie', devise: 'ZK', tva: [16, 0], paiement: 'generic' },
  { code: 'ZW', nom: 'Zimbabwe', devise: '$', tva: [15, 0], paiement: 'generic' },
  { code: 'BW', nom: 'Botswana', devise: 'P', tva: [14, 0], paiement: 'generic' },
  { code: 'MZ', nom: 'Mozambique', devise: 'MT', tva: [16, 0], paiement: 'generic' },
  { code: 'NA', nom: 'Namibie', devise: '$', tva: [15, 0], paiement: 'generic' },
  { code: 'AF', nom: 'Afghanistan', devise: '؋', tva: [10, 0], paiement: 'generic' },
  { code: 'AG', nom: 'Antigua-et-Barbuda', devise: 'EC$', tva: [17, 0], paiement: 'generic' },
  { code: 'BS', nom: 'Bahamas', devise: 'B$', tva: [10, 0], paiement: 'generic' },
  { code: 'BB', nom: 'Barbade', devise: 'Bds$', tva: [17.5, 0], paiement: 'generic' },
  { code: 'BZ', nom: 'Belize', devise: 'BZ$', tva: [12.5, 0], paiement: 'generic' },
  { code: 'BT', nom: 'Bhoutan', devise: 'Nu.', tva: [7, 0], paiement: 'generic' },
  { code: 'BI', nom: 'Burundi', devise: 'FBu', tva: [18, 10, 0], paiement: 'generic' },
  { code: 'CV', nom: 'Cap-Vert', devise: 'Esc', tva: [15, 0], paiement: 'generic' },
  { code: 'CF', nom: 'Centrafrique', devise: 'FCFA', tva: [19, 5, 0], paiement: 'generic' },
  { code: 'TD', nom: 'Tchad', devise: 'FCFA', tva: [18, 9, 0], paiement: 'generic' },
  { code: 'KM', nom: 'Comores', devise: 'CF', tva: [10, 0], paiement: 'generic' },
  { code: 'DJ', nom: 'Djibouti', devise: 'Fdj', tva: [10, 0], paiement: 'generic' },
  { code: 'DM', nom: 'Dominique', devise: 'EC$', tva: [15, 10, 0], paiement: 'generic' },
  { code: 'GQ', nom: 'Guinée équatoriale', devise: 'FCFA', tva: [15, 6, 0], paiement: 'generic' },
  { code: 'ER', nom: 'Érythrée', devise: 'Nfk', tva: [5, 0], paiement: 'generic' },
  { code: 'SZ', nom: 'Eswatini', devise: 'E', tva: [15, 0], paiement: 'generic' },
  { code: 'FJ', nom: 'Fidji', devise: 'FJ$', tva: [12.5, 0], paiement: 'generic' },
  { code: 'GM', nom: 'Gambie', devise: 'D', tva: [15, 0], paiement: 'generic' },
  { code: 'GD', nom: 'Grenade', devise: 'EC$', tva: [15, 0], paiement: 'generic' },
  { code: 'GW', nom: 'Guinée-Bissau', devise: 'FCFA', tva: [19, 0], paiement: 'generic' },
  { code: 'GY', nom: 'Guyana', devise: 'G$', tva: [14, 0], paiement: 'generic' },
  { code: 'HT', nom: 'Haïti', devise: 'G', tva: [10, 0], paiement: 'generic' },
  { code: 'JM', nom: 'Jamaïque', devise: 'J$', tva: [15, 0], paiement: 'generic' },
  { code: 'KI', nom: 'Kiribati', devise: '$', tva: [12.5, 0], paiement: 'generic' },
  { code: 'KG', nom: 'Kirghizistan', devise: 'с', tva: [12, 0], paiement: 'generic' },
  { code: 'LS', nom: 'Lesotho', devise: 'M', tva: [15, 0], paiement: 'generic' },
  { code: 'LR', nom: 'Liberia', devise: 'L$', tva: [10, 0], paiement: 'generic' },
  { code: 'LY', nom: 'Libye', devise: 'ل.د', tva: [0], paiement: 'generic' },
  { code: 'MW', nom: 'Malawi', devise: 'MK', tva: [16.5, 0], paiement: 'generic' },
  { code: 'MV', nom: 'Maldives', devise: 'Rf', tva: [8, 17, 0], paiement: 'generic' },
  { code: 'MH', nom: 'Îles Marshall', devise: '$', tva: [0], paiement: 'generic' },
  { code: 'MR', nom: 'Mauritanie', devise: 'UM', tva: [16, 0], paiement: 'generic' },
  { code: 'FM', nom: 'Micronésie', devise: '$', tva: [0], paiement: 'generic' },
  { code: 'NR', nom: 'Nauru', devise: '$', tva: [0], paiement: 'generic' },
  { code: 'KP', nom: 'Corée du Nord', devise: '₩', tva: [0], paiement: 'generic' },
  { code: 'PW', nom: 'Palaos', devise: '$', tva: [10, 0], paiement: 'generic' },
  { code: 'PG', nom: 'Papouasie-Nouvelle-Guinée', devise: 'K', tva: [10, 0], paiement: 'generic' },
  { code: 'KN', nom: 'Saint-Kitts-et-Nevis', devise: 'EC$', tva: [17, 10, 0], paiement: 'generic' },
  { code: 'LC', nom: 'Sainte-Lucie', devise: 'EC$', tva: [12.5, 0], paiement: 'generic' },
  {
    code: 'VC',
    nom: 'Saint-Vincent-et-les-Grenadines',
    devise: 'EC$',
    tva: [16, 0],
    paiement: 'generic',
  },
  { code: 'WS', nom: 'Samoa', devise: 'WS$', tva: [15, 0], paiement: 'generic' },
  { code: 'ST', nom: 'Sao Tomé-et-Principe', devise: 'Db', tva: [15, 0], paiement: 'generic' },
  { code: 'SC', nom: 'Seychelles', devise: 'SR', tva: [15, 0], paiement: 'generic' },
  { code: 'SL', nom: 'Sierra Leone', devise: 'Le', tva: [15, 0], paiement: 'generic' },
  { code: 'SB', nom: 'Îles Salomon', devise: 'SI$', tva: [10, 0], paiement: 'generic' },
  { code: 'SO', nom: 'Somalie', devise: 'Sh', tva: [5, 0], paiement: 'generic' },
  { code: 'SS', nom: 'Soudan du Sud', devise: 'SSP', tva: [18, 0], paiement: 'generic' },
  { code: 'SD', nom: 'Soudan', devise: 'SDG', tva: [17, 0], paiement: 'generic' },
  { code: 'SR', nom: 'Suriname', devise: 'Sr$', tva: [10, 0], paiement: 'generic' },
  { code: 'SY', nom: 'Syrie', devise: 'LS', tva: [0], paiement: 'generic' },
  { code: 'TJ', nom: 'Tadjikistan', devise: 'ЅМ', tva: [14, 0], paiement: 'generic' },
  { code: 'TL', nom: 'Timor oriental', devise: '$', tva: [2.5, 0], paiement: 'generic' },
  { code: 'TO', nom: 'Tonga', devise: 'T$', tva: [15, 0], paiement: 'generic' },
  { code: 'TT', nom: 'Trinité-et-Tobago', devise: 'TT$', tva: [12.5, 0], paiement: 'generic' },
  { code: 'TM', nom: 'Turkménistan', devise: 'm', tva: [15, 0], paiement: 'generic' },
  { code: 'TV', nom: 'Tuvalu', devise: '$', tva: [7, 0], paiement: 'generic' },
  { code: 'VU', nom: 'Vanuatu', devise: 'VT', tva: [15, 0], paiement: 'generic' },
  { code: 'YE', nom: 'Yémen', devise: '﷼', tva: [5, 0], paiement: 'generic' },
  { code: 'PS', nom: 'Palestine', devise: '₪', tva: [16, 0], paiement: 'generic' },
  { code: 'VA', nom: 'Vatican', devise: '€', tva: [0], paiement: 'iban' },
];

export const PAYS_BY = Object.fromEntries(PAYS.map((p) => [p.code, p]));

/**
 * La langue de chaque pays : choisir le pays règle aussi la langue de
 * l'interface, des documents et des courriels. La Suisse n'y figure pas :
 * français, allemand ou italien, l'entreprise garde celle qu'elle a choisie.
 */
export const LANGUE_DU_PAYS = {
  FR: 'fr',
  BE: 'fr',
  LU: 'fr',
  MC: 'fr',
  SN: 'fr',
  CI: 'fr',
  CM: 'fr',
  CD: 'fr',
  CG: 'fr',
  GA: 'fr',
  ML: 'fr',
  BF: 'fr',
  BJ: 'fr',
  TG: 'fr',
  NE: 'fr',
  GN: 'fr',
  MG: 'mg',
  DE: 'de',
  AT: 'de',
  LI: 'de',
  IT: 'it',
  SM: 'it',
  ES: 'es',
  MX: 'es',
  AR: 'es',
  CL: 'es',
  CO: 'es',
  PE: 'es',
  UY: 'es',
  VE: 'es',
  EC: 'es',
  BO: 'es',
  PY: 'es',
  CR: 'es',
  PA: 'es',
  GT: 'es',
  HN: 'es',
  SV: 'es',
  NI: 'es',
  DO: 'es',
  CU: 'es',
  PT: 'pt',
  BR: 'pt',
  AO: 'pt',
  MZ: 'pt',
  NL: 'nl',
  PL: 'pl',
  SE: 'sv',
  DK: 'da',
  NO: 'no',
  FI: 'fi',
  CZ: 'cs',
  RO: 'ro',
  MD: 'ro',
  HU: 'hu',
  HR: 'hr',
  BA: 'bs',
  SK: 'sk',
  SI: 'sl',
  EE: 'et',
  LV: 'lv',
  LT: 'lt',
  AL: 'sq',
  XK: 'sq',
  IS: 'is',
  GR: 'el',
  CY: 'el',
  BG: 'bg',
  RU: 'ru',
  BY: 'be',
  UA: 'uk',
  RS: 'sr',
  ME: 'sr',
  MK: 'mk',
  TR: 'tr',
  SA: 'ar',
  AE: 'ar',
  QA: 'ar',
  EG: 'ar',
  MA: 'ar',
  TN: 'ar',
  DZ: 'ar',
  JO: 'ar',
  LB: 'ar',
  KW: 'ar',
  BH: 'ar',
  OM: 'ar',
  IQ: 'ar',
  CN: 'zh',
  TW: 'zh-tw',
  HK: 'zh-tw',
  JP: 'ja',
  KR: 'ko',
  IN: 'hi',
  ID: 'id',
  VN: 'vi',
  TH: 'th',
  MY: 'ms',
  BN: 'ms',
  PH: 'tl',
  IR: 'fa',
  PK: 'ur',
  IL: 'he',
  KE: 'sw',
  TZ: 'sw',
  BD: 'bn',
  LK: 'si',
  NP: 'ne',
  ET: 'am',
  KZ: 'kk',
  UZ: 'uz',
  GE: 'ka',
  AM: 'hy',
  AZ: 'az',
  KH: 'km',
  MM: 'my',
  MN: 'mn',
  LA: 'lo',
  AD: 'ca',
  GB: 'en',
  US: 'en',
  IE: 'en',
  MT: 'mt',
  CA: 'en',
  AU: 'en',
  NZ: 'en',
  SG: 'en',
  ZA: 'af',
  NG: 'ha',
  GH: 'ak',
  UG: 'sw',
  RW: 'rw',
  ZM: 'ny',
  ZW: 'sn',
  BW: 'tn',
  NA: 'af',
  MU: 'fr',
  AF: 'ps',
  AG: 'en',
  BS: 'en',
  BB: 'en',
  BZ: 'en',
  BT: 'dz',
  BI: 'rn',
  CV: 'pt',
  CF: 'fr',
  TD: 'fr',
  KM: 'fr',
  DJ: 'fr',
  DM: 'en',
  GQ: 'es',
  ER: 'ti',
  SZ: 'ss',
  FJ: 'en',
  GM: 'en',
  GD: 'en',
  GW: 'pt',
  GY: 'en',
  HT: 'ht',
  JM: 'en',
  KI: 'en',
  KG: 'ky',
  LS: 'st',
  LR: 'en',
  LY: 'ar',
  MW: 'ny',
  MV: 'dv',
  MH: 'en',
  MR: 'ar',
  FM: 'en',
  NR: 'en',
  KP: 'ko',
  PW: 'en',
  PG: 'en',
  KN: 'en',
  LC: 'en',
  VC: 'en',
  WS: 'sm',
  ST: 'pt',
  SC: 'en',
  SL: 'en',
  SB: 'en',
  SO: 'so',
  SS: 'en',
  SD: 'ar',
  SR: 'nl',
  SY: 'ar',
  TJ: 'tg',
  TL: 'pt',
  TO: 'to',
  TT: 'en',
  TM: 'tk',
  TV: 'en',
  VU: 'en',
  YE: 'ar',
  PS: 'ar',
  VA: 'it',
};
